import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Building2 } from "lucide-react";
import { api } from "../../lib/api";

export const EnterpriseNav = () => {
  const [ok, setOk] = useState(false);
  useEffect(() => { api.get("/enterprise/access").then((r) => setOk(r.data.allowed)).catch(() => {}); }, []);
  if (!ok) return null;
  return (
    <NavLink to="/app/enterprise" className={({ isActive }) => `flex items-center gap-3 px-3 py-2 text-sm border-l-2 transition-colors ${isActive ? "border-brand text-white bg-white/[0.04]" : "border-transparent text-white/55 hover:text-white"}`} data-testid="nav-enterprise">
      <Building2 className="w-4 h-4" />Enterprise partners (private)
    </NavLink>
  );
};

export const STAGE_LABEL = { prospect: "Prospect", vetting: "Vetting", negotiating: "Negotiating", signed: "Signed", live: "Live", declined: "Declined" };
export const CRIT_LABEL = { strategic_fit: "Strategic fit", distribution_reach: "Distribution reach", technical_capability: "Technical capability",
  financial_stability: "Financial stability", reputation_compliance: "Reputation & compliance", exclusivity_risk: "Low exclusivity / conflict risk" };
export const field = "w-full bg-field border border-fieldline px-3 py-2 text-sm focus:outline-none focus:border-brand disabled:opacity-50";
export const currentQuarter = () => { const d = new Date(); return `${d.getFullYear()}-Q${Math.floor(d.getMonth() / 3) + 1}`; };
export const quarters = () => { const out = []; const d = new Date(); let y = d.getFullYear(), q = Math.floor(d.getMonth() / 3) + 1;
  for (let i = 0; i < 8; i += 1) { out.push(`${y}-Q${q}`); q -= 1; if (!q) { q = 4; y -= 1; } } return out; };
